// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1i-VT","paramInput":"JobSimulator_paramInput__3tk1h","input":"JobSimulator_input__3qdsa"};